import config from 'react-global-configuration';
import {configService} from './../configService';
import axios from 'axios';
// import { useSelector } from 'react-redux';

export const userService = {
    login,
    logout,
    getCurruncies,
    signup,
    signup2,
    refreshProfileSummary,
    userLoginCheck,
    refreshAccessToken
}

function userLoginCheck(user) {
    console.log('userLoginCheck res',user)
    return axios
        .post(`${config.get('apiUrl')}/wallet/usercheck`, user)
        .then(configService.handleResponse)
        .then(res => {
       
        return res;
    })
    .catch(err => configService.handleApiError(err));
}
function login(username, password) {
    return axios
        .post(`${config.get('apiUrl')}/signin`, {
            username,
            password
        })
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => configService.handleApiError(err));
}
function getCurruncies(){
    return axios
        .get(`${config.get('apiUrl')}/get-curruncies`)
        .then(configService.handleResponse)
        .then(res => {
            return res;
        })
        .catch(err => configService.handleApiError(err));
}
function refreshAccessToken() {
    const refreshtoken =  localStorage.getItem('refreshtoken');
    return axios
        .post(`${config.get('apiUrl')}/refresh-token`, {
            refresh_token: refreshtoken,
        })
        .then(configService.handleResponse)
        .then(response => {
            return response;
        })
         .catch(error => {
            if (error.response && error.response.status === 401) {
                logoutUser();
            }
            throw error;
        });
}
function logoutUser() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshtoken');
    localStorage.removeItem('gameData');
}
function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshtoken');
    localStorage.removeItem('gameData');
     window.location.href = '/?login';
    window.location.reload(true);
}
function signup(user) {
    return axios
        .post(`${config.get('apiUrl')}/signup`, user)
        .then(configService.handleResponse)
        .then(res => {
            console.log('service res',res)
            return res;
        })
        .catch(err => configService.handleApiError(err));
}
function signup2(user,email,username,password) {

    return axios
        .post(`${config.get('apiUrl')}/signup`, [user,email,username,password])
        .then(configService.handleResponse)
        .then(res => {
            return res;
        })
        .catch(err => configService.handleApiError(err));
}
function refreshProfileSummary(){
    return axios
        .get(`${config.get('apiUrl')}/profile-summary`)
        .then(configService.handleResponse)
        .then(res => {
            return res;
        })
        .catch(err => configService.handleApiError(err));
}
